import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import { FaUserCircle } from "react-icons/fa";
// import AccountCircle from '@mui/icons-material/AccountCircle';
import { BsBank } from "react-icons/bs";
import { FaUser } from "react-icons/fa6";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { GiMoneyStack } from "react-icons/gi";
import { bankWithdraw, cleanwithdraw } from "../../redux/Slice/authSlice";
import { toast } from "react-toastify";
const Withdraw = ({ paypal }) => {
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const withdrawResponse = useSelector((state) => state?.auth?.withdraw);
  const dispatch = useDispatch();
  const [bankData, setBankData] = useState({
    amount: "",
    accountNumber: "",
    accountHolderName: "",
    swiftCode: "",
    bankName: "",
    paypalId: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmited, setIsSubmitted] = useState(false);
  const [isErr, setIsErr] = useState(withdrawResponse?.message);

  const withdrawHandler = () => {
    const newErrors = {};

    if (paypal) {
      if (!bankData.paypalId.trim()) {
        newErrors.paypalId = "Paypal ID is required";
      }
    } else {
      // Validate 'accountNumber'
      if (!bankData.accountNumber.trim()) {
        newErrors.accountNumber = "Account Number is required";
      }
      // else if (bankData.accountNumber.trim().length !== 16 || isNaN(bankData.accountNumber)) {
      //     newErrors.accountNumber = 'Account Number must be 16 digits';
      // }

      // Validate 'accountHolderName'
      if (!bankData.accountHolderName.trim()) {
        newErrors.accountHolderName = "Account Holder Name is required";
      }

      // Validate 'swiftCode'
      if (!bankData.swiftCode.trim()) {
        newErrors.swiftCode = "Swift Code is required";
      }

      // Validate 'bankName'
      if (!bankData.bankName.trim()) {
        newErrors.bankName = "Bank Name is required";
      }
    }
    // Validate 'amount'
    if (!bankData.amount.trim()) {
      newErrors.amount = "Amount is required";
    }

    // Set the errors
    setErrors(newErrors);

    // Check if newErrors is not empty
    if (Object.keys(newErrors).length !== 0) {
      return; // Return early if there are validation errors
    }
    setErrors(newErrors);
    if (Object.keys(newErrors).length !== 0) {
      return; // Return early if there are validation errors
    } else {
      setErrors({});
    }
    if (paypal) {
      dispatch(
        bankWithdraw({
          type: "paypal",
          userId: userDetail?.data?._id,
          withdrawAmount: bankData?.amount,
          accountNumber: "",
          accountHolderName: "",
          swiftCode: "",
          bankName: "",
          paypalId: bankData?.paypalId,
        })
      );
    } else {
      dispatch(
        bankWithdraw({
          type: "bank",
          userId: userDetail?.data?._id,
          withdrawAmount: bankData?.amount,
          accountNumber: bankData?.accountNumber,
          accountHolderName: bankData?.accountHolderName,
          swiftCode: bankData?.swiftCode,
          bankName: bankData?.bankName,
          paypalId: bankData?.paypalId,
        })
      );
    }
  };
  const paypalRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const amountRegex = /^\d+(\.\d{1,2})?$/;
  const nameRegex = /^[A-Za-z\s]+$/;
  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  const ifscAllowedCharsRegex = /^[A-Z0-9]*$/;
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "amount" || name === "accountNumber") {
      if (amountRegex.test(value) || value === "") {
        setBankData({ ...bankData, [name]: value });
      }
    } else if (name === "accountHolderName" || name === "bankName") {
      if (nameRegex.test(value) || value === "") {
        setBankData({ ...bankData, [name]: value });
      }
    } else if (name === "swiftCode") {
      if (ifscAllowedCharsRegex.test(value) || value === "") {
        setBankData({ ...bankData, [name]: value });
      }
    }
    //  else if (name === "paypalId") {
    //   if (paypalRegex.test(value) || value === "") {
    //     setBankData({ ...bankData, [name]: value });
    //   }
    // }
    else {
      setBankData({ ...bankData, [name]: value });
    }
  };

  useEffect(() => {
    if (withdrawResponse?.success === true) {
      toast(withdrawResponse?.message);
    } else {
      toast(withdrawResponse?.message);
    }
  }, [withdrawResponse]);
  useEffect(() => {
    return () => {
      dispatch(cleanwithdraw());
    };
  }, []);

  return (
    <div className="d-flex justify-content-center">
      <Box
        className="min-windth-773 text-center"
        sx={{
          "& > :not(style)": { p: 2 },
          border: "1px solid black",
          borderRadius: 2,
        }}
      >
        <Typography variant="h" component="h3" className="text-center m-2 ">
          {paypal ? "To Paypal" : "To Bank Account"}
        </Typography>
        <FormControl fullWidth>
          <TextField
            autoComplete
            error={errors?.amount}
            sx={{ m: 1, width: "98%" }}
            id="amount"
            label="Amount"
            placeholder="Enter Amount"
            value={bankData?.amount}
            name="amount"
            onChange={handleChange}
            helperText={errors?.amount}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <GiMoneyStack />
                </InputAdornment>
              ),
            }}
          />
        </FormControl>
        {paypal ? (
          <FormControl fullWidth>
            <TextField
              autoComplete
              sx={{ m: 1, width: "98%" }}
              id="paypalId"
              label="Paypal ID"
              placeholder="Enter Paypal ID"
              value={bankData?.paypalId}
              onChange={handleChange}
              name="paypalId"
              helperText={errors?.paypalId}
              error={errors?.paypalId}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <FaUserCircle />
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
        ) : (
          <>
            <FormControl fullWidth>
              <TextField
                autoComplete
                sx={{ m: 1, width: "98%" }}
                id="accountNumber"
                label="Account Number"
                placeholder="Enter Account Number"
                value={bankData?.accountNumber}
                helperText={errors?.accountNumber}
                error={errors?.accountNumber}
                onChange={handleChange}
                name="accountNumber"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <BsBank />
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>
            <FormControl fullWidth>
              <TextField
                autoComplete
                sx={{ m: 1, width: "98%" }}
                id="accountHolder"
                label="Account Holder Name"
                placeholder="Enter Account Holder Name"
                value={bankData?.accountHolderName}
                onChange={handleChange}
                helperText={errors?.accountHolderName}
                error={errors?.accountHolderName}
                name="accountHolderName"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <FaUser />
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>
            <FormControl fullWidth>
              <TextField
                autoComplete
                sx={{ m: 1, width: "98%" }}
                id="swiftCode"
                label="IFSC Code"
                placeholder="Enter Swift Code"
                value={bankData?.swiftCode}
                onChange={handleChange}
                helperText={errors?.swiftCode}
                error={errors?.swiftCode}
                name="swiftCode"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <FaUserCircle />
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>
            <FormControl fullWidth>
              <TextField
                autoComplete
                sx={{ m: 1, width: "98%" }}
                id="brnachName"
                label="Branch Name"
                placeholder="Enter Bank Name"
                value={bankData?.bankName}
                onChange={handleChange}
                error={errors?.bankName}
                helperText={errors?.bankName}
                name="bankName"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <FaUserCircle />
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>
          </>
        )}
        <Stack spacing={2} direction="row" className="justify-content-center">
          <Button
            variant="contained"
            className="d-block  btn w-50 px-3 img-btn primaryColor mt-4"
            onClick={withdrawHandler}
          >
            Submit{" "}
          </Button>
        </Stack>
      </Box>
    </div>
  );
};

export default Withdraw;
